export default __webpack_public_path__ + "locales/az/InfoPanel.json?hash=8cf797a4b307b1a85045a3c47bb92598";